import type { Session } from './types';

let csrfToken = '';

export function setCSRFToken(token?: string) {
  csrfToken = token ?? '';
}

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const headers = new Headers(options.headers);
  headers.set('accept', 'application/json');
  if (options.body && !headers.has('content-type')) headers.set('content-type', 'application/json');
  if (csrfToken && options.method && options.method !== 'GET') headers.set('x-csrf-token', csrfToken);
  const response = await fetch(path, { ...options, headers, credentials: 'same-origin' });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload?.error?.message ?? `Request failed (${response.status})`);
  return (payload.data ?? payload) as T;
}

export async function loadSession(): Promise<Session> {
  const session = await api<Session>('/api/v1/session');
  setCSRFToken(session.csrf_token);
  return session;
}

